import { useRef } from "react";

function usePrevious<T>(value: T): T {
  const ref = useRef(value);
  if (value) ref.current = value;
  return value || ref.current;
}

export default usePrevious;
